<app-top-menubar></app-top-menubar>
<app-home-tope-banner></app-home-tope-banner>
<app-home-middlebar></app-home-middlebar>
<app-home-benefits></app-home-benefits>
<app-home-bottom-banner></app-home-bottom-banner>
<app-home-stepper></app-home-stepper>
<app-common-footer></app-common-footer>